import ChannelStatusPage from "@/components/channels/ChannelStatusPage";
import { mailDeck } from "./mailExplainer";

/** Help Genie Mail channel page — product intro and SSO handoff into Mail. */
const MailChannelPage = () => <ChannelStatusPage appId="mail" deck={mailDeck} />;

export default MailChannelPage;
